// extracted by mini-css-extract-plugin
module.exports = {"example":"VoiceAssistant_example__6Fkdt","VoiceAssistant":"VoiceAssistant_VoiceAssistant__nq3gm"};